export enum ServiceStatus {
  DOES_NOT_EXIST,
  SUCCESS,
  SYSTEM_FAILURE,
  TIMEOUT,
}
